export const CONTRACTS = '/contracts';
export const FOLLOW_UP_CONTRACTS = '/followUpContract';
